import './ParentPages.css';

/**
 * Safeguarding + wellbeing resources hub. Required by §22.13: links
 * to NSPCC + YoungMinds + Mind + Childline + FA Wellbeing.
 *
 * Static link list with brief intros. No API calls.
 */
export function ParentResources() {
  return (
    <>
      <header className="parent-page__head">
        <span className="parent-page__eyebrow">Safeguarding</span>
        <h1 className="parent-page__title">Resources for parents</h1>
        <p className="parent-page__lead">
          If you're worried about your child — or want to understand the
          safeguarding context behind 4CM — these are the people and pages we
          recommend. The Welfare Officer at your child's club is always your
          first port of call inside 4CM.
        </p>
      </header>

      <section className="resources">
        <article className="resources__entry">
          <h2>NSPCC</h2>
          <p>
            UK children's charity. 24-hour helpline for concerns about a
            child, advice for parents, and the home of the
            <em> National Child Protection Helpline</em>.
          </p>
          <ul>
            <li><a href="tel:08088005000">0808 800 5000</a> — 24-hour helpline</li>
            <li><a href="https://www.nspcc.org.uk" target="_blank" rel="noreferrer">nspcc.org.uk</a></li>
          </ul>
        </article>

        <article className="resources__entry">
          <h2>Childline</h2>
          <p>
            Free, confidential support for under-19s in the UK. Children can
            call 24/7. Parents can use the site to learn how to talk to a
            child about a difficult subject.
          </p>
          <ul>
            <li><a href="tel:08001111">0800 1111</a> — free, 24/7</li>
            <li><a href="https://www.childline.org.uk" target="_blank" rel="noreferrer">childline.org.uk</a></li>
          </ul>
        </article>

        <article className="resources__entry">
          <h2>YoungMinds</h2>
          <p>
            Mental-health charity for young people. Crisis Messenger reaches
            a counsellor by text any time, free.
          </p>
          <ul>
            <li>
              Text <code>YM</code> to <code>85258</code> — Crisis Messenger
            </li>
            <li><a href="https://www.youngminds.org.uk" target="_blank" rel="noreferrer">youngminds.org.uk</a></li>
          </ul>
        </article>

        <article className="resources__entry">
          <h2>Samaritans</h2>
          <p>
            Free, confidential listening for anyone in distress, any age,
            any time of day or night.
          </p>
          <ul>
            <li><a href="tel:116123">116 123</a> — free, 24/7</li>
            <li><a href="https://www.samaritans.org" target="_blank" rel="noreferrer">samaritans.org</a></li>
          </ul>
        </article>

        <article className="resources__entry">
          <h2>Mind</h2>
          <p>
            Mental-health charity offering information, advice, and local
            services for anyone struggling with their mental wellbeing.
          </p>
          <ul>
            <li><a href="https://www.mind.org.uk" target="_blank" rel="noreferrer">mind.org.uk</a></li>
          </ul>
        </article>

        <article className="resources__entry">
          <h2>FA Wellbeing</h2>
          <p>
            The Football Association's wellbeing hub for players, coaches,
            and parents in grassroots football.
          </p>
          <ul>
            <li><a href="https://www.thefa.com/get-involved/player/heads-up" target="_blank" rel="noreferrer">thefa.com</a></li>
          </ul>
        </article>

        <article className="resources__entry">
          <h2>NHS</h2>
          <p>
            Non-emergency medical advice + signposting to your GP.
          </p>
          <ul>
            <li><a href="tel:111">111</a> — non-emergency</li>
            <li><a href="https://www.nhs.uk/mental-health/" target="_blank" rel="noreferrer">nhs.uk/mental-health</a></li>
          </ul>
        </article>
      </section>

      <p className="parent-page__footnote">
        4CM is not a substitute for professional support. If you or your child
        are in immediate danger, please call <strong>999</strong>.
      </p>
    </>
  );
}
